import BusinessIcon from '@mui/icons-material/Business'
import DateRangeIcon from '@mui/icons-material/DateRange'
import BookingsPage from 'Pages/BookingsPage/BookingsPage/BookingsPage'
import BookingStatusPage from 'Pages/Client/BookingStatusPage/BookingStatusPage'
import ClientSearchPage from 'Pages/Client/ClientSearchPage/ClientSearchPage'
import { StateResourceType } from '../../app/constants/Dashboard/DashboardConstants'
import BookingConfirmationPage from '../../Pages/BookingsPage/BookingConfirmationPage/BookingConfirmationPage'
import CreateBookingPageSwitch from '../../Pages/BookingsPage/CreateBookingPage/CreateBookingPageSwitch'
import ClientManagementPage from '../../Pages/Client/ClientManagementPage/ClientManagementPage'
import AuthRoutes from '../AuthRoutes/authRoutes'
import ClientResourceRoutes from '../ResourceRoutes/clientRoutes'
import { getHomeRoutes } from './homeRoutes'
import UserProfileRoutes from './userProfileRoutes'

export const cAStateRoutes = [
  {
    stateRouteId: 1,
    stateSource: StateResourceType.CLIENT,
    stateField: 'clientId',
  },
]

export function useClientAdminRoutes(user: any, client: any) {
  return [
    ...AuthRoutes,
    // ...ClientResourceRoutes,
    ...UserProfileRoutes,

    {
      stateRouteId: 1,
      path: '/clients/',
      name: 'My Company',
      navBarHeading: 'My Company',
      rtlName: 'هعذاتسجيل الدخول',
      mini: '',
      rtlMini: '',
      component: ClientManagementPage,
      layout: '/admin',
    },
    {
      collapse: true,
      name: 'Clients',
      rtlName: 'صفحات',
      icon: BusinessIcon,
      state: 'clientCollapse',
      views: [
        {
          path: '/clients/search',
          name: 'Find a Client',
          navBarHeading: 'Client Search',
          rtlName: 'إدارة الموردين',
          mini: '',
          rtlMini: '',
          component: ClientSearchPage,
          layout: '/admin',
        },
        ...ClientResourceRoutes,
      ],
    },
    {
      collapse: true,
      name: 'Bookings',
      rtlName: 'صفحات',
      icon: DateRangeIcon,
      state: 'bookingsCollapse',
      views: [
        {
          path: '/bookings/myBookings',
          navBarHeading: 'Bookings',
          name: 'Bookings',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: BookingsPage,
          layout: '/admin',
        },
        {
          path: '/bookings/create?new=true',
          navBarHeading: 'Bookings',
          name: 'Create New Booking',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: CreateBookingPageSwitch,
          layout: '/admin',
        },
        {
          path: '/bookings/journeyStatus',
          navBarHeading: 'Journey Status',
          name: 'Journey Status',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: BookingStatusPage,
          layout: '/admin',
        },
        {
          path: '/bookings/create',
          navBarHeading: 'Bookings',
          name: 'Create Booking',
          component: CreateBookingPageSwitch,
          layout: '/admin',
          redirect: true,
        },
        {
          path: '/bookings/confirmation',
          navBarHeading: 'Booking Confirmation',
          name: 'Booking Confirmation',
          component: BookingConfirmationPage,
          layout: '/admin',
          redirect: true,
        },
      ],
    },
    ...getHomeRoutes(client),
  ]
}
